export default __webpack_public_path__ + "static/media/mShorts_1_c1.8ddd51ba.jpeg";